// extracted by mini-css-extract-plugin
module.exports = {"avatar":"custom-trackers-list_avatar_3_JOK"};